import {
  GET_ACTION_LOGS_FAIL,
  GET_ACTION_LOGS_REQUEST,
  GET_ACTION_LOGS_SUCCESS,
  GET_ACTION_LOG_DETAIL_FAIL,
  GET_ACTION_LOG_DETAIL_REQUEST,
  GET_ACTION_LOG_DETAIL_SUCCESS,
} from "src/constants/types";

export const historyReducers = (state = {}, actions) => {
  const { payload } = actions;
  switch (actions.type) {
    case GET_ACTION_LOGS_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case GET_ACTION_LOGS_SUCCESS:
      return {
        ...state,
        loading: false,
        actionLogs: payload,
      };
    case GET_ACTION_LOGS_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    case GET_ACTION_LOG_DETAIL_REQUEST:
      return {
        ...state,
        loading: true,
        error: "",
      };
    case GET_ACTION_LOG_DETAIL_SUCCESS:
      return {
        ...state,
        loading: false,
        actionLogDetail: payload,
      };
    case GET_ACTION_LOG_DETAIL_FAIL:
      return {
        ...state,
        loading: false,
        error: payload,
      };

    default:
      return state;
  }
};
